'use client';

import { useCallback, useMemo } from 'react';
import { useScale } from '@/lib/api/rewards-hub/hooks';
import { rankArt } from './leaderboardTheme';

/**
 * The board sends a rank INDEX, never words or pictures: the names and rank
 * art come from `GET /rewards/scale`, the one localized source of that copy.
 * Until the scale is in, a rank has no title (the cell waits rather than
 * printing a number).
 */
export function useScaleLookup() {
  const { data: scale } = useScale();

  const ranks = useMemo(
    () => new Map((scale?.ranks ?? []).map((rank) => [rank.index, rank])),
    [scale],
  );

  const rankTitle = useCallback(
    (rankIndex: number | null): string | null =>
      rankIndex === null ? null : (ranks.get(rankIndex)?.title ?? null),
    [ranks],
  );

  const rankImage = useCallback(
    (rankIndex: number): string => ranks.get(rankIndex)?.image || rankArt(rankIndex),
    [ranks],
  );

  return { rankTitle, rankImage };
}
